import { ACCOUNT_SETTINGS_PAGES } from '../routing/routeConfiguration';

/**
 * Whether a Racing Theme topbar custom link should render as the active nav item.
 *
 * @param {Object} params
 * @param {Object} params.linkConfig
 * @param {string|null|undefined} params.currentPage
 * @returns {boolean}
 */
export const isRacingThemeTopbarLinkActive = ({ linkConfig, currentPage }) => {
  const { type, route } = linkConfig || {};

  if (type === 'internal' && route) {
    const { name, params } = route;
    const hasPageName = pageName => currentPage?.indexOf(pageName) === 0;
    const isCMSPage = pageId => hasPageName('CMSPage') && currentPage === `CMSPage:${pageId}`;
    const isInboxPage = tab => hasPageName('InboxPage') && currentPage === `InboxPage:${tab}`;
    const isCurrentPage = currentPage === name;

    if (isCMSPage(params?.pageId) || isInboxPage(params?.tab) || isCurrentPage) {
      return true;
    }
  }

  return false;
};

/**
 * Whether a profile dropdown item matches the current page.
 *
 * @param {string} page
 * @param {string|null|undefined} currentPage
 * @returns {boolean}
 */
export const isProfileMenuPageActive = (page, currentPage) => {
  const isAccountSettingsPage =
    page === 'AccountSettingsPage' && ACCOUNT_SETTINGS_PAGES.includes(currentPage);
  const isInboxPage =
    currentPage?.indexOf('InboxPage') === 0 && page?.indexOf('InboxPage') === 0;
  return currentPage === page || isAccountSettingsPage || isInboxPage;
};

/**
 * Whether the search page is the current route.
 *
 * @param {string|null|undefined} currentPage
 * @returns {boolean}
 */
export const isSearchPageActive = currentPage =>
  currentPage === 'SearchPage' || currentPage === 'SearchPageWithListingType';
